import {
    Component,
    inject,
    input,
    viewChild,
    ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RendererService, ComponentMap } from '../../services/renderer.service';
import { NavbarHofComponent } from '../../components/hof/navbar-hof/navbar-hof.component';
import { FooterHofComponent } from '../../components/hof/footer-hof/footer-hof.component';
import { CartService } from '../../services/cart.service';
import { SlugService } from '../../services/slug.service';

const COMPONENT_MAP: ComponentMap = {
    ComponentMainHofPage: import(
        '../../components/hof/hof-page/hof-page.component'
    ).then((m) => m.HofPageComponent),
    ComponentMainDivider: () =>
        import('../../components/common/divider/divider.component').then(
            (m) => m.DividerComponent,
        ),
    ComponentMainNotFound: () =>
        import('../../components/common/not-found/not-found.component').then(
            (m) => m.NotFoundComponent,
        ),
    ComponentMainTextImage: () =>
        import('../../components/common/text-image/text-image.component').then(
            (m) => m.TextImageComponent,
        ),
    ComponentMainGallery: () =>
        import('../../components/common/gallery/gallery.component').then(
            (m) => m.GalleryComponent,
        ),
    ComponentMainSlider: () =>
        import('../../components/common/slider/slider.component').then(
            (m) => m.SliderComponent,
        ),
    ComponentMainTextField: () =>
        import('../../components/common/text-field/text-field.component').then(
            (m) => m.TextfieldComponent,
        ),
    ComponentMainTextFieldMarkdown: () =>
        import(
            '../../components/common/text-field-markdown/text-field-markdown.component'
        ).then((m) => m.TextFieldMarkdownComponent),
    ComponentMainContactHof: () =>
        import('../../components/hof/contact-hof/contact-hof.component').then(
            (m) => m.ContactHofComponent,
        ),
    ComponentMainFullProduct: import(
        '../../components/hof/full-product/full-product.component'
    ).then((m) => m.FullProductComponent),
    ComponentMainShop: import('../../components/hof/shop/shop.component').then(
        (m) => m.ShopComponent,
    ),
    ComponentMainBlog: import('../../components/hof/blog/blog.component').then(
        (m) => m.BlogComponent,
    ),
    ComponentMainMoreProducts: () =>
        import(
            '../../components/hof/more-products/more-products.component'
        ).then((m) => m.MoreProductsComponent),
    ComponentMainFullBlogPost: import(
        '../../components/hof/blog/full-blog-post/full-blog-post.component'
    ).then((m) => m.FullBlogPostComponent),
    ComponentMainNewsletter: import(
        '../../components/hof/newsletter/newsletter.component'
    ).then((m) => m.NewsletterComponent),
    ComponentMainNewsletterPopup: import(
        '../../components/hof/newsletter-popup/newsletter-popup.component'
    ).then((m) => m.NewsletterPopupComponent),
    ComponentMainFullImage: import(
        '../../components/common/full-image/full-image.component'
    ).then((m) => m.FullImageComponent),
    ComponentMainPartner: () =>
        import('../../components/hof/partner/partner.component').then(
            (m) => m.PartnerComponent,
        ),
    ComponentMainTestimonials: () =>
        import(
            '../../components/apartment/testimonials/testimonials.component'
        ).then((m) => m.TestimonialsComponent),
    ComponentMainMap: import('../../components/common/map/map.component').then(
        (m) => m.MapComponent,
    ),
    ComponentMainAnimals: () =>
        import('../../components/hof/animals/animals.component').then(
            (m) => m.AnimalsComponent,
        ),
    ComponentMainImageWithFiveCaptions: () =>
        import(
            '../../components/common/image-with-five-captions/image-with-five-captions.component'
        ).then((m) => m.ImageWithFiveCaptionsComponent),
    ComponentMainYoutubeVideo: () =>
        import(
            '../../components/common/youtube-video/youtube-video.component'
        ).then((m) => m.YoutubeVideoComponent),
} as { [key: string]: any };

@Component({
    selector: 'app-hof-renderer',
    standalone: true,
    imports: [NavbarHofComponent, FooterHofComponent],
    host: { class: 'block relative font-futura' },
    templateUrl: './hof-renderer.component.html',
})
export class HofRendererComponent {
    productSlug = input<string>();
    viewContainerRef = viewChild('viewContainerRef', {
        read: ViewContainerRef,
    });
    cartService = inject(CartService);
    private activatedRoute = inject(ActivatedRoute);
    private rendererService = inject(RendererService);
    private slugService = inject(SlugService);

    ngOnInit() {
        this.activatedRoute.params.subscribe((params) => {
            this.slugService.setSlug = params['slug'];
        });

        this.activatedRoute.data.subscribe(async (response: any) => {
            const data = response.page;
            this.rendererService.viewContainerRef.set(this.viewContainerRef());
            this.rendererService.loadComponents(
                data,
                COMPONENT_MAP,
                data.data[0]?.title,
                this.productSlug(),
            );
        });
    }
}
